<template>
  <div class="background">
    <v-main>
      <v-container>
        <v-card
          style="
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
            border-radius: 16px;
            margin-top: 48px;
            padding: 16px 0px 33px 0px;
          "
        >
          <v-col style="text-align: center">
            <img
              src="@/assets/img/mobileAuthIcons/welcomeIcon.png"
              style="max-width: 294px; max-height: 246px"
            />
            <p
              style="
                font-family: 'Gilroy-Bold';
                font-size: 32px;
                line-height: 38px;
                color: #5e5e5e;
                margin-top: 40px;
              "
            >
              <strong>{{ "hoozie_label\n" | localize }}<br>{{ 'mobile_login_business_account_label' | localize }}</strong>
            </p>
            <p
              style="
                font-size: 18px;
                line-height: 21px;
                text-align: center;
                color: #515151;
                margin-top: 5px;
              "
            >
              {{ "sign_in_welcome_label1" | localize }}
              <strong style="color: #73afe7">{{
                "sign_in_welcome_label2" | localize
              }}</strong>
              - {{ "sign_in_welcome_label3" | localize }}
            </p>
            <p
              style="
                font-size: 14.8272px;
                line-height: 17px;
                text-decoration-line: underline;
                color: #73afe7;
                margin-top: 8px;
              "
            >
              <strong>
                {{ "mobile_create_business_how_does_it_work" | localize }}
              </strong>
            </p>
            <v-btn
              style="
                background: #73afe7;
                border: 1px solid #ffffff;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
                border-radius: 90px;
                font-size: 14.8272px;
                line-height: 17px;
                text-transform: none;
                color: #ffffff;
                margin-top: 20px;
              "
              width="100%"
              max-width="323px"
              height="32px"
              @click="$router.push('/signup')"
            >
              {{ "button_login_create" | localize }}
              <v-icon color="white" style="margin-left: 4px"
                >mdi-account-plus-outline</v-icon
              >
            </v-btn>
            <v-btn
              style="
                background: white;
                border: 1px solid #73afe7;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
                border-radius: 90px;
                font-size: 14.8272px;
                line-height: 17px;
                text-transform: none;
                color: #73afe7;
                margin-top: 20px;
              "
              width="100%"
              max-width="323px"
              height="32px"
              @click="$router.push('/login')"
            >
              {{ "sign_in" | localize }}
              <button-icon style="margin-left: 4" color="#73AFE7" />
            </v-btn>
          </v-col>
        </v-card>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import buttonIcon from "./icons/button-icon.vue";
export default {
  components: { buttonIcon },
  mounted() {
    console.log("vuetfiy", this.$vuetify.breakpoint.xs);
  },
};
</script>

<style>
.background {
  background-image: url("../../assets/img/mobileAuthIcons/mobileBackground.svg");
  color: #5e5e5e;
  height: 800px;
  width: 100%;
  background-size: auto;
  background-repeat: repeat;
}
</style>